var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7643 10.013L2.26429 19.513M12.7827 2.55144C14.0007 3.35964 15.1714 4.31247 16.2654 5.40646C17.3689 6.50989 18.3287 7.69137 19.1413 8.92072M8.01925 6.90911L5.14438 5.95082C4.8133 5.84046 4.44863 5.91069 4.18221 6.13612L1.32505 8.55371C0.740127 9.04865 0.906306 9.99055 1.62529 10.2554L4.33249 11.2528M10.4453 17.3655L11.4427 20.0727C11.7076 20.7917 12.6495 20.9579 13.1445 20.3729L15.562 17.5158C15.7875 17.2494 15.8577 16.8847 15.7473 16.5536L14.7891 13.6787M18.1129 1.2837L13.2064 2.10144C12.6766 2.18974 12.1907 2.45015 11.8237 2.84238L5.21065 9.91153C3.49649 11.7439 3.54417 14.6055 5.31842 16.3797C7.09268 18.154 9.95425 18.2017 11.7866 16.4875L18.8558 9.87443C19.248 9.5075 19.5084 9.02156 19.5967 8.49175L20.4145 3.58528C20.6401 2.23164 19.4665 1.05809 18.1129 1.2837Z",
    stroke: "#750AC4",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.e69c05ace7429d05f65912e8edd838a3.svg";
export { ForwardRef as ReactComponent };